import { z } from "zod";

/**
 * Admin — monitoring BullMQ front. Jména front jsou pevně definovaná;
 * když se přidá nová fronta, musí se rozšířit tenhle enum.
 */
export const queueNameEnum = z.enum([
  "welcome-email",
  "hca-email-send",
  "hca-campaign-scheduler",
  "hca-serial-tick",
  "invoice-issue",
  "hca-faktura-auto-issue",
  "hca-kontakt-notify",
  "hca-diagnoza-notify",
  "hca-prihlaska-confirm",
  "auth-password-setup",
  "hca-aktivita-reminder",
]);
export type QueueName = z.infer<typeof queueNameEnum>;

export const listFailedJobsSchema = z.object({
  queueName: queueNameEnum,
  limit: z.number().int().min(1).max(100).default(20),
});

/** Pauze/obnovení fronty nebo retry všech failed. */
export const queueActionSchema = z.object({
  queueName: queueNameEnum,
});

/** Retry konkrétního jobu. */
export const retryJobSchema = z.object({
  queueName: queueNameEnum,
  jobId: z.string().min(1, "ID jobu je povinné").max(200, "ID jobu musí být 200 znaků nebo méně"),
});

export type ListFailedJobsInput = z.infer<typeof listFailedJobsSchema>;
export type QueueActionInput = z.infer<typeof queueActionSchema>;
export type RetryJobInput = z.infer<typeof retryJobSchema>;
